'use client';

import ProviderSearch from './ProviderSearch';
import SavedProviderList from './SavedProviderList';
import { ComponentFields } from 'types/content';
import { useAppSelector } from 'lib/hooks';
import { selectProviders } from 'slices/doctorSlice';
import CheckCircleIcon from 'components/icons/CheckCircleIcon';
import { useEffect, useRef } from 'react';
import { ANALYTICS_EVENTS, capture, secondsSince } from 'lib/analytics';

const ProviderForm = ({ data, onContinue }: ComponentFields) => {
  const savedProviders = useAppSelector(selectProviders);
  const mountTimeRef = useRef<number | null>(null);
  useEffect(() => {
    mountTimeRef.current = Date.now();
    capture(ANALYTICS_EVENTS.providersFormViewed);
  }, []);

  const title = data.elements.title.value;
  const subtitle = data.elements.subtitle.value;
  const continueEmpty = data.elements.continueTextEmpty.value;
  const continuePopulated = data.elements.continueTextPopulated.value;

  const handleContinue = () => {
    capture(ANALYTICS_EVENTS.providersFormCompleted, {
      duration_seconds: secondsSince(mountTimeRef.current),
    });
    onContinue();
  };

  return (
    <section className="form-container large providers-form">
      <ProviderSearch title={title} subtitle={subtitle} />
      <SavedProviderList providers={savedProviders} />
      <button
        className={`button ${
          savedProviders.length === 0 ? 'secondary' : 'primary checked'
        }`}
        onClick={handleContinue}
      >
        {savedProviders.length === 0 ? continueEmpty : continuePopulated}
        {savedProviders.length > 0 && <CheckCircleIcon color="white" />}
      </button>
    </section>
  );
};

export default ProviderForm;
